import React from "react";
import { Switch, Route } from "react-router-dom";
import constants from "../constants";
import OnlineAndFaq from "Help/OnlineAndFaq";
import GuideDownloadPage from "pages/ThankYouDownload/GuideDownloadPage";
import GuideThankPage from "pages/ThankYouDownload/GuideThankPage";
import EbookDownloadPage from "pages/ThankYouDownload/EbookDownloadPage";
import EbookThankPage from "pages/ThankYouDownload/EbookThankPage";
import GetStarted from "pages/Get-started";
import DemoRequestPage from "pages/DemoRequestPage";
import DemoRequestThank from "pages/DemoRequestPage/DemoRequestThank";

/**
 * Online FAQ and landing page routes
 */
const OnlineFaqRoutes = () => {
  return (
    <Switch>
      <Route component={<>Home</>} exact path="/" />
      <Route
        render={() => <OnlineAndFaq data="FAQForAccountOwner" />}
        path="/owner/faq"
      />
      <Route
        render={() => <OnlineAndFaq data="FAQForStaff" />}
        path="/staff/faq"
      />
      <Route
        render={() => <OnlineAndFaq data="FAQForPatient" />}
        path="/patient/faq"
      />
      <Route
        render={() => <OnlineAndFaq data="OnlineHelpForAccountOwner" />}
        path="/owner/help"
      />
      <Route
        render={() => <OnlineAndFaq data="OnlineHelpForStaff" />}
        path="/staff/help"
      />
      <Route
        render={() => <OnlineAndFaq data="OnlineHelpForPatient" />}
        path="/patient/help"
      />

      <Route
        render={() => (
          <GuideDownloadPage
            hubspotType={constants.hubspotFormPages.guideDownloadPage}
          />
        )}
        path={constants.routes.landingPages.guideDownloadPage}
      />
      <Route
        render={() => (
          <GuideDownloadPage
            hubspotType={constants.hubspotFormPages.fbGuideHubspotPage}
          />
        )}
        path={constants.routes.landingPages.guideDownloadPageFb}
      />
      <Route
        render={() => (
          <GuideDownloadPage
            hubspotType={constants.hubspotFormPages.gglGuideHubspotPage}
          />
        )}
        path={constants.routes.landingPages.guideDownloadPageGgl}
      />
      <Route
        render={() => (
          <GuideDownloadPage
            hubspotType={constants.hubspotFormPages.smGuideHubspotPage}
          />
        )}
        path={constants.routes.landingPages.guideDownloadPageSm}
      />
      <Route
        component={GuideThankPage}
        path={constants.routes.landingPages.guideThankPage}
      />

      <Route
        render={() => (
          <EbookDownloadPage
            hubspotType={constants.hubspotFormPages.ebookDownloadPage}
          />
        )}
        path={constants.routes.landingPages.ebookDownloadPage}
      />
      <Route
        render={() => (
          <EbookDownloadPage
            hubspotType={constants.hubspotFormPages.fbHubspotPage}
          />
        )}
        path={constants.routes.landingPages.ebookDownloadPageFb}
      />
      <Route
        render={() => (
          <EbookDownloadPage
            hubspotType={constants.hubspotFormPages.gglHubspotPage}
          />
        )}
        path={constants.routes.landingPages.ebookDownloadPageGgl}
      />
      <Route
        render={() => (
          <EbookDownloadPage
            hubspotType={constants.hubspotFormPages.smHubspotPage}
          />
        )}
        path={constants.routes.landingPages.ebookDownloadPageSm}
      />
      <Route
        component={EbookThankPage}
        path={constants.routes.landingPages.ebookThankPage}
      />
      <Route component={GetStarted} path={constants.routes.getStarted} />
      <Route
        component={DemoRequestPage}
        path={constants.routes.demoRequestPage}
      />
      <Route
        component={DemoRequestThank}
        path={constants.routes.demoRequestThank}
      />
    </Switch>
  );
};

export default OnlineFaqRoutes;
